import React, { useState, useEffect } from 'react';
import { googleReady } from './TranslateWidget';
import './CustomLanguageDropdown.css';

const LANGS = [
    { code: '', label: 'Select Language' },

    // Global Popular Languages
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
    { code: 'fr', label: 'French' },
    { code: 'de', label: 'German' },
    { code: 'zh-CN', label: 'Chinese (Simplified)' },
    { code: 'ar', label: 'Arabic' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'ru', label: 'Russian' },
    { code: 'ja', label: 'Japanese' },

    // Indian Popular Languages
    { code: 'hi', label: 'Hindi' },
    { code: 'gu', label: 'Gujarati' },
    { code: 'mr', label: 'Marathi' },
    { code: 'ta', label: 'Tamil' },
    { code: 'te', label: 'Telugu' },
    { code: 'bn', label: 'Bengali' },
    { code: 'ml', label: 'Malayalam' },
    { code: 'kn', label: 'Kannada' },
    { code: 'ur', label: 'Urdu' },
    { code: 'pa', label: 'Punjabi' }
];

const CustomLanguageDropdown = () => {
    const [value, setValue] = useState('');

    useEffect(() => {
        const esc = (e) => e.key === 'Escape' && setValue('');
        window.addEventListener('keydown', esc);
        return () => window.removeEventListener('keydown', esc);
    }, []);

    const handleChange = (e) => {
        const lang = e.target.value;
        setValue(lang);
        if (!lang) return;

        const sendToGoogle = () => {
            const combo = document.querySelector('.goog-te-combo');
            if (combo) {
                combo.value = lang;
                combo.dispatchEvent(new Event('change'));
                return true;
            }
            return false;
        };

        if (googleReady.current && sendToGoogle()) return;

        let tries = 0;
        const id = setInterval(() => {
            if (sendToGoogle() || ++tries > 10) clearInterval(id);
        }, 200);

        setTimeout(() => {
            if (!googleReady.current) {
                const u = encodeURIComponent(window.location.href);
                window.location.href = `https://translate.google.com/translate?hl=${lang}&sl=en&u=${u}`;
            }
        }, 2200);
    };

    return (
        <select
            className="custom-lang-select"
            value={value}
            onChange={handleChange}
        >
            {LANGS.map(({ code, label }) => (
                <option key={code} value={code}>
                    {label}
                </option>
            ))}
        </select>
    );
};

export default CustomLanguageDropdown;
